export default __webpack_public_path__ + "static/media/tool_item_blue1.b8146943.png";